export default "__VITE_ASSET__B5K5HQmD__"